@import '../../../constants/spacing.module.less';

.modal-upload-section {
  padding: @space-16;
}

.section-header {
  align-items: center;
  flex-wrap: nowrap;
}

.refresh-icon {
  width: 14px;
  height: 14px;
}
